<template>
  <a-modal v-model="modal" title="叫料通知表" width="90%" :maskClosable="false" :closable="true" :destroyOnClose="true">
    <ls-table-layout>
      <div class="table-page-search-wrapper" slot="search">
        <ls-search-form @search="onReSearch" @reset="resetQuery" :formList="formList" ref="refSearchForm">
          <global-select
            slot="organizationCode"
            :value.sync="queryParams.organizationCodeList"
            selectType="selectMultipleFilter"
            requestApi="/system/user/inventOrgAll"
            :selectItem="{ value: 'realValue', label: 'label' }"
          />
        </ls-search-form>
      </div>
      <div class="table-page-operator-wrapper" slot="btn">
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1 || isEdit" @click="onCallNotify" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:pushDown']">下推叫料通知</a-button>
        <a-button :loading="loading" :disabled="selectedRows.length < 1 || isEdit" @click="onCopy" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:copyRow']">复制行</a-button>
        <a-button :loading="loading" :disabled="isEdit" @click="onDownloadNotify" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:export']">导出</a-button>
        <a-button :loading="loading" :disabled="isEdit" @click="onImport" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:callImport']">导入</a-button>
        <a-button type="primary" :loading="loading" :disabled="selectedRows.length < 1 || isEdit" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:refresh']" @click="onRefresh">刷新可叫料数</a-button>
      </div>
      <template v-slot:table>
        <div class="page-header-content">
          <a-form-model ref="baseForm" class="baseForm" :model="formData">
            <ls-metable
              class="orderMaterialTable"
              :columns="columns"
              :data-list="formData.infos"
              :scroll="{y:400, x:1600}"
              :customRow="(record, index) => index"
              :row-selection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
              rowKey="id"
              size="middle"
              :loading="tableLoading"
              :IsEdit="false"
              :needAdd="false"
              :pagination="pagination"
              @change="handleTableChange"
            >
              <!--叫料量-->
              <span slot="callQtyTitle">
                <i class="toRequired">*</i>叫料量
              </span>
              <template slot="callQty" slot-scope="{text,record,index}">
                <a-form-model-item
                  :prop="`infos.${index}.callQty`"
                  :rules="{
                    'required':(isEdit && currentId === record.id)||(callNotifyCheck && selectedRowKeys.includes(record.id)),
                    'message':' ',
                    'trigger':'blur',
                    'validator':(rule,value,callback)=>{ callQtyCheck(rule,value,callback,record,index)}}" >
                  <a-input-number
                    v-model="record.callQty"
                    :min="0"
                    :max="Number(record.canCallQty || 0)"
                    :disabled="!isEdit || currentId !== record.id"
                    :formatter="(value) => `${value}`.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')"
                    :parser="(value) => value.replace(/^(\-)*(\d+)\.(\d{2}).*$/, '$1$2.$3', '')" />
                </a-form-model-item>
              </template>
              <!--材料商-->
<!--              <span slot="materialSupplierTitle">
                <i class="toRequired">*</i>材料商
              </span>-->
              <template slot="materialSupplier" slot-scope="{text,record,index}">
                <a-form-model-item :prop="`infos.${index}.materialSupplier`">
                  <global-select
                    :value.sync="record.materialSupplier"
                    :selectData="[]"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                  />
<!--                  <global-select
                    :disabled="!isEdit || currentId !== record.id"
                    :value.sync="record.materialSupplier"
                    selectType="selectFilter"
                    requestApi="/scp/scpDirectDeliveryCallManager/materialSupplierCombobox"
                    :selectItem="{ value: 'realValue', label: 'label' }"
                    :setParams="{ organizationCode: record.organizationCode, rawMaterialCode: record.rawMaterialCode }"
                    @successCallBack="(data) => supplierCallBack(data, record, index)"
                  />-->
                </a-form-model-item>
              </template>
              <!--要求送达时间-->
              <span slot="planDeliveryTimeTitle">
                <i class="toRequired">*</i>要求送达时间
              </span>
              <template slot="planDeliveryTime" slot-scope="{text,record,index}">
                <a-form-model-item
                  :rules="{
                    'required':(isEdit && currentId === record.id)||(callNotifyCheck && selectedRowKeys.includes(record.id)),
                    'message':' ',
                    'trigger':'change'}"
                  :prop="`infos.${index}.planDeliveryTime`">
                  <a-date-picker style="width: 100%" v-model="record.planDeliveryTime" valueFormat="YYYY-MM-DD 00:00:00" :disabled="!isEdit || currentId !== record.id" />
                </a-form-model-item>
              </template>
              <!--备注-->
              <template slot="remark" slot-scope="{text,record}">
                <a-input type="textarea" :autoSize="{minRows:2}" v-model="record.remark" :maxLength="100" :disabled="!isEdit || currentId !== record.id" />
              </template>
              <span slot="operation" slot-scope="{ text, record }">
                <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpDirectDeliverySelfCallManager:callEdit']">编辑</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
            </ls-metable>
          </a-form-model>
        </div>
      </template>
    </ls-table-layout>
    <template #footer />
    <download-modal :apiFun="apiMaterialExportCallNotice" ref="download" @closeDown="closeDown" />
    <import-excel ref="importExcelRef" :downloadParams="downloadParams" :uploadParams="upload" @refresh="onReSearch" />
  </a-modal>
</template>

<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash.clonedeep'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
import ImportExcel from "@/views/finished-goods-order/base-data/supplier-process-ranking/components/importExcel"
import {
  apiClearSaveCallNotify,
  apiGetCallNoticeList,
  apiMaterialExportCallNotice,
  apiMaterialPushCallNotice,
  apiRefreshCanCallQtyVirtual,
  apiSaveCopyCallNotice,
  apiUpdateDirectDeliveryCallNotice
} from '@/api/scp/work-order-material/material-work-order-material'
import { CREATE_COLUMNS } from '@/views/scp/factoryCallMaterial/selfOrderMaterial/enum'
import moment from 'moment'

export default {
  name: 'CreateOrderMaterial',
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  components: { ImportExcel, DownloadModal },
  data() {
    return {
      apiMaterialExportCallNotice,
      // 导入模板下载参数
      downloadParams: {
        method: 'post',
        url: 'scp/scpDirectDeliveryCallManager/callNoticeTemplate',
        name: `直送材料叫料通知导入模板_${moment().format('YYYY-MM-DD')}.xlsx`
      },
      // 用户导入参数
      upload: {
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpDirectDeliveryCallManager/importCallNotice' // 上传的地址
      },
      ids: [], // 选择数据的id集合
      isEdit: false,
      callNotifyCheck: false, // 下推校验标识
      modal: false,
      currentId: "",
      soleFlag: '', // 后端要求入参的判断标识
      // 查询参数
      queryParams: {
        organizationCodeList: undefined,
        planDeliveryTime: undefined,
        planDeliveryTimeFrom: undefined,
        planDeliveryTimeTo: undefined,
        requiredDeliveryDate: undefined,
        requiredDeliveryDateFrom: undefined,
        requiredDeliveryDateTo: undefined,
        rawMaterialCode: undefined
      },
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 可选的每页条数
        showTotal: (total, range) => `共${total}条记录` // 显示总数据量及当前页范围
      },
      formData: { infos: [] },
      tableLoading: false, // table加载
      loading: false,
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 表格字段
      columns: CREATE_COLUMNS,
      formList: [
        { label: '加工组织', decorator: ['organizationCode'], type: 'organizationCode' },
        {
          label: '要求到料时间',
          type: 'range',
          decorator: ['requiredDeliveryDate'],
          disposeFormat: {
            requiredDeliveryDateFrom: (change) => { return change[0].format('yyyy-MM-DD 00:00:00') },
            requiredDeliveryDateTo: (change) => { return change[1].format('yyyy-MM-DD 23:59:59') }
          }
        },
        {
          label: '要求送货日期',
          type: 'range',
          decorator: ['planDeliveryTime'],
          disposeFormat: {
            planDeliveryTimeFrom: (change) => {
              return change[0].format('yyyy-MM-DD 00:00:00')
            },
            planDeliveryTimeTo: (change) => {
              return change[1].format('yyyy-MM-DD 23:59:59')
            }
          }
        },
        { label: '原材料编码', decorator: ['rawMaterialCode'], type: 'input' }
      ]
    }
  },
  methods: {
    // 下载完成跳转下载中心关闭弹窗
    closeDown() {
      this.modal = false
    },
    // 供应商接口回调，默认拿第一个
    supplierCallBack(data, record, index) {
      if(data?.length > 0) {
        this.$set(this.formData.infos[index], 'materialSupplier', data[0]?.realValue)
      }
    },
    // 刷新可叫料数
    onRefresh() {
      if (this.selectedRows.find(v => v?.id === 'newId')) {
        this.$message.warning('请勾选已保存数据')
        return false
      }
      this.loading = true;
      const paramList = this.selectedRows.map(item => {
        const { id, rawMaterialCode, materialModel, canCallQty, organizationCode } = item
        return { id, rawMaterialCode, materialModel, canCallQty, organizationCode }
      })
      apiRefreshCanCallQtyVirtual(paramList).then(res => {
        if (res?.code === 200) {
          this.$message.success('刷新成功')
          this.onReSearch() // 查询
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 校验叫料量大于0
    callQtyCheck(rule, value, callback, record) {
      if(((this.isEdit && this.currentId === record.id) || (this.callNotifyCheck && this.selectedRowKeys.includes(record.id))) && Number(record.callQty) === 0) {
        // eslint-disable-next-line standard/no-callback-literal
        return callback(' ')
      }
     return callback()
    },
    // 导出
    onDownloadNotify() {
      const obj = JSON.parse(JSON.stringify({ ...this.queryParams, ids: this.ids }))
      this.$refs.download.openModal(obj)
    },
    // 导入
    onImport() {
      this.upload.url = process.env.VUE_APP_API_BASE_URL + '/scp/scpDirectDeliveryCallManager/importCallNotice' + `/${this.soleFlag}`
      this.$refs.importExcelRef.show()
    },
    // 编辑-保存
    handleSave (record) {
      this.callNotifyCheck = false;
      this.$nextTick(() => {
        this.$refs.baseForm.validate(valid => {
          if(valid) {
            this.loading = true;
            const params = cloneDeep(record)
            params.soleFlag = this.soleFlag; // 复制行/保存也添加标识
            // if(params.id === 'newId') { params.copyFlag = 'Y' } // 复制行，后端要求传标识Y
            if (params.id === 'newId' && params?.id) { params.id = '' } // 复制行id清空
            // 复制行用保存接口，更新用更新接口
            const requestApi = params.id ? apiUpdateDirectDeliveryCallNotice : apiSaveCopyCallNotice;
            requestApi(params).then(res => {
              if (res?.code === 200) {
                this.$message.success('保存成功')
                this.onSearch()
                this.currentId = ''
                this.isEdit = false;
              }
            }).finally(() => {
              this.loading = false;
            })
          } else {
            this.$message.warning('请检查必填项')
          }
        })
      })
    },
    // 取消
    handleCancel () {
      this.handleQuery()
    },
    // 搜索按钮操作
    handleQuery () {
      this.$nextTick(() => {
        this.onSearch()
      })
    },
    // 行选中
    onSelectChange(selectedRowKeys, selectedRows) {
      // this.selectedRowKeys = selectedRowKeys;
      this.selectedRowKeys = selectedRows.map(v => v.id);
      this.selectedRows = selectedRows
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      pager.pageSize = pagination.pageSize;
      this.pagination = pager;
      this.onSearch()
    },
    // 复制行
    onCopy() {
      if (this.selectedRows.length === 1) {
        const newObj = cloneDeep(this.selectedRows[0])
        newObj.id = 'newId' // 标识新数据
        this.isEdit = true;
        this.currentId = newObj.id;
        // 如果超出一页总数，先删除最后一个，再添加复制行，避免出现分页出错问题
        if (this.formData?.infos?.length === this.pagination?.pageSize) {
          this.formData.infos.splice(this.formData.infos.length - 1, 1)
        }
        this.formData.infos.unshift(newObj)
      } else {
        this.$message.warning('只能选择一条数据复制')
      }
    },
    // 下推叫料通知
    onCallNotify() {
      if (this.selectedRows.find(v => v?.id === 'newId')) {
        this.$message.warning('请勾选已保存数据')
        return false
      }
      this.callNotifyCheck = true;
      const this_ = this;
      setTimeout(() => {
        this_.$refs.baseForm.validate(valid => {
          if(valid) {
            this_.loading = true;
            apiMaterialPushCallNotice(this_.selectedRows).then(res => {
              if (res?.code === 200) {
                this_.$message.success('操作成功')
                this_.callNotifyCheck = false;
                this_.onReSearch() // 查询
              }
            }).finally(() => {
              this_.loading = false;
            })
          } else {
            this_.$message.warning('请检查必填项')
          }
        })
      }, 100)
    },
    // 初始化查询
    show(data) {
      this.pagination.current = 1;
      this.pagination.pageSize = 10;
      this.pagination.total = 0;
      this.ids = data.map(item => item.id)
      this.cleanData()
      // this.resetQuery()
      this.modal = true
    },
    // 初始化清空
    cleanData() {
      this.loading = true;
      this.soleFlag = '';
      this.formData.infos = []
      apiClearSaveCallNotify({ ids: this.ids }).then(res => {
        if (res?.code === 200) {
          this.soleFlag = res?.data
          this.resetQuery() // 后端要求，必须要执行完清空接口才去查询,接口返回作为soleFlag参数给查询接口
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    // 重新查询，从第一页
    onReSearch(value = {}) {
      const params = Object.assign({}, this.queryParams, value)
      delete params.searchFormLabel
      this.queryParams = { ...this.queryParams, ...params, soleFlag: this.soleFlag }
      this.pagination.current = 1;
      this.pagination.total = 0;
      this.onSearch()
    },
    // 重置按钮操作
    resetQuery () {
      this.queryParams = {
        organizationCodeList: undefined,
        planDeliveryTime: undefined,
        planDeliveryTimeFrom: undefined,
        planDeliveryTimeTo: undefined,
        requiredDeliveryDate: undefined,
        requiredDeliveryDateFrom: undefined,
        requiredDeliveryDateTo: undefined,
        rawMaterialCode: undefined
      }
      this.onReSearch()
    },
    // 编辑
    handleEdit (record) {
      this.callNotifyCheck = false
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.callNotifyCheck = false
      this.currentId = ''
      this.formData.infos = []
      this.onSelectChange([], []) // 清除选择
      const params = {
        ids: this.ids,
        ...this.queryParams,
        pageNum: this.pagination?.current,
        pageSize: this.pagination?.pageSize || 10
      }
      this.tableLoading = true;
      apiGetCallNoticeList(params).then(res => {
        if (res?.data?.code === 200 && res?.data?.rows?.length > 0) {
          this.formData.infos = res.data.rows
          this.pagination.total = res.data.total
        } else {
          this.pagination.total = 0
        }
      }).finally(() => {
        this.tableLoading = false;
      })
    }
  },
  mounted () {
    this.loading = false;
    this.tableLoading = false;
  }
}
</script>

<style lang="less" scoped>
.orderMaterialTable{
  /deep/ .ant-form-item{
    margin-bottom: 0;
  }
  /deep/ .ant-form-explain, .ant-form-extra{
    min-height: 0;
    height: 0;
  }
}

</style>
